import { render, staticRenderFns } from "./BodyguardServiceView.vue?vue&type=template&id=0285d331&scoped=true"
import script from "./BodyguardServiceView.vue?vue&type=script&lang=js"
export * from "./BodyguardServiceView.vue?vue&type=script&lang=js"
import style0 from "./BodyguardServiceView.vue?vue&type=style&index=0&id=0285d331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0285d331",
  null
  
)

export default component.exports